import styled from 'styled-components/macro'
import breakpoints from 'assets/stylesheet'

const SearchResultItem = styled.li`
  width: 50%;
  @media (min-width: ${breakpoints.contentWrapLarge}) {
    width: 33.3%;
  }
  @media (max-width: ${breakpoints.bpDesktopPx}) {
    width: 100%;
  }
`

export default SearchResultItem
